export default __webpack_public_path__ + "static/media/logo.bb454774.svg";